"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lists = void 0;
/**
 * NIP-51 list types
 */
var Lists;
(function (Lists) {
    Lists["Muted"] = "mute";
    Lists["Pinned"] = "pin";
    Lists["Bookmarked"] = "bookmark";
    Lists["Followed"] = "follow";
    Lists["Badges"] = "profile_badges";
})(Lists = exports.Lists || (exports.Lists = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9zdHIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbm9zdHIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBd0VBOztHQUVHO0FBQ0gsSUFBWSxLQU1YO0FBTkQsV0FBWSxLQUFLO0lBQ2YsdUJBQWMsQ0FBQTtJQUNkLHVCQUFjLENBQUE7SUFDZCxnQ0FBdUIsQ0FBQTtJQUN2Qiw0QkFBbUIsQ0FBQTtJQUNuQixrQ0FBeUIsQ0FBQTtBQUMzQixDQUFDLEVBTlcsS0FBSyxHQUFMLGFBQUssS0FBTCxhQUFLLFFBTWhCIn0=